import { render, staticRenderFns } from "./MagicLink.vue?vue&type=template&id=370d09a9&scoped=true"
import script from "./MagicLink.vue?vue&type=script&lang=js"
export * from "./MagicLink.vue?vue&type=script&lang=js"
import style0 from "./MagicLink.vue?vue&type=style&index=0&id=370d09a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370d09a9",
  null
  
)

export default component.exports